import React, { useState } from "react";
import axios from "axios";

export default function WeatherApp(){
    const [data, setData] = useState({});
    const [location, setLocation] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [icon, setIcon ] = useState();
    
    const [favName, setFavName] = useState("")
  function searchDataCelsius() {
    axios
      .get(`https://api.openweathermap.org/data/2.5/weather?q=${location}&units=metric&appid=39dbe63ca34880b70244fb075b6b1b7f`)
      .then((response) => {
        setData(response?.data);
        setIcon(response?.data?.weather[0]?.icon)
        setErrorMessage("");
        // console.log(response.data)
      })
      .catch((error) => {
        setErrorMessage("Please try again.");
        console.log(error);
      });

    
  }

    
    return(
        <section className="flex flex-col py-[20px] h-[70vh] items-center justify-center bg-[#f7f7f7] w-[100%] expoSpace">
            <h1 className="text-[20px]">What's the weather like?</h1>

            <div className="py-[30px] flex flex-row sm:px-[50px] px-[20px] items-center justify-center  w-[100%]">
            <input 
                    className="border-solid border-[1px] border-[black] 
                rounded-[15px] px-[20px] py-[10px] w-[85%] mr-[10px]" 
                placeholder="Search location"
                type="text"
                value={location}
                onChange={(e) => {
                    setLocation(e?.target?.value)
                }}
            />
            <button className="flex flex-col items-center justify-center 
            rounded-[15px] bg-[#14e956] py-[10px] px-[20px]
            "
            onClick={searchDataCelsius}
            >
                Go!
            </button>
            </div>

            {
                data?.name && 
                <section 
                style={{
                    boxShadow:" 0px 25px 20px -20px rgba(0,0,0,0.45)"
                }}
                className="flex  flex-row bg-white py-[30px]  items-end justify-center w-[100%] px-[20px] sm:px-[50px]">
                <div className="pr-[20px] flex flex-col items-start justify-start">
                <img 
                    src={`http://openweathermap.org/img/wn/${icon}.png`}
                    alt="icon"
                />
                <h1 className="text-[30px]">{data?.main?.temp}°C</h1>
                <h2 className="capitalize text-[grey]">{data?.name}{", "}{data?.sys?.country}</h2>
                </div>
                
                <div className="flex flex-row items-center ">
                    <div className="pr-[10px]">
                        <h1 className="sm:text-[15px] text-[12px]">Humidity</h1>
                        <h1>{data?.main?.humidity}</h1>
                    </div>
                    <div className="pr-[10px]">
                        <h1 className="sm:text-[15px] text-[12px]">Max temp.</h1>
                        <h1>{data?.main?.temp_max}</h1>
                    </div>
                    <div className="pr-[10px]">
                        <h1 className="sm:text-[15px] text-[12px]">Min temp.</h1>
                        <h1>{data?.main?.temp_min}</h1>
                    </div>
                </div>

                </section>
            }

            {/* <div className="pt-[30px] flex flex-col items-center  w-[100%]">
                <h1 className="text-[20px]">Favorite location(s)</h1>

                <div className="pt-[10px] flex flex-row items-center justify-center w-[100%] sm:px-[50px] px-[20px] ">
                    <input 
                    className="border-solid border-[1px] border-[black] 
                rounded-[15px] px-[20px] py-[10px] w-[85%] mr-[10px]" 
                placeholder="Add to favorite"
                value={favName}
                onChange={(e) => {
                    setFavName(e?.target?.value)
                }}
                    />
            <button className="flex flex-col items-center justify-center 
            rounded-[15px] bg-[#14e956] py-[10px] px-[20px]
            "
            onClick={addFav}
            >
               Add
            </button>
                </div>
            </div> */}
        </section>
    )
}